import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Kurs_eura } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-kurs-eura',
  templateUrl: './kurs-eura.component.html',
  styleUrls: ['./kurs-eura.component.scss']
})
export class KursEuraComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#kursEuraGrid' };
  createKursEuraPopupVisible: boolean = false;
  editKursEuraPopupVisible: boolean = false;
  isUserModerator: boolean = false;
  selectedKursEura: Kurs_eura;

  @ViewChild('kursEuraGrid', { static: false }) kursEuraGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    
    try {
      const result = await this.apiClient.kursEuraAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
      this.gridData = result;

    } catch (error) {
      console.error('Error loading kurs eura data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateKursEura() {
    this.createKursEuraPopupVisible = true;
  }

  async onKursEuraCreated(e: Kurs_eura) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const kursEura = e.row.data;

    try {
      await this.apiClient.kursEuraDELETE(kursEura.id);

      const index = this.gridData.findIndex(item => item.id === kursEura.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting kurs eura:', error);
    }
  }
}